import { hasPermission } from './Permissions'

export const canCobranzaRecordsView = () => hasPermission('cobranza.records.view')
export const canCobranzaRecordsExport = () => hasPermission('cobranza.records.export')
export const canCobranzaBitacoraView = () => hasPermission('cobranza.bitacora.view')
export const canCobranzaBitacoraExport = () => hasPermission('cobranza.bitacora.export')
export const canCobranzaFollowUpCreate = () => hasPermission('cobranza.follow_up.create')
export const canCobranzaFollowUpView = () => hasPermission('cobranza.follow_up.view')
export const canCobranzaCatalogsView = () => hasPermission('cobranza.catalogs.view')
export const canCobranzaCatalogsEdit = () => hasPermission('cobranza.catalogs.edit')

export function hasAnyCobranzaMenuAccess() {
    return (
        canCobranzaRecordsView() ||
        canCobranzaBitacoraView() ||
        canCobranzaCatalogsView() ||
        canCobranzaFollowUpCreate()
    )
}
